/* eslint-disable @typescript-eslint/no-explicit-any */
import EnvUtil from './EnvUtil';

function enable() {
  return EnvUtil.isTestRuntime();
}

function log(...data: any[]) {
  if (enable()) {
    console.log(data);
  }
}

function info(...data: any[]) {
  if (enable()) {
    console.info(data);
  }
}

function debug(...data: any[]) {
  if (enable()) {
    console.debug(data);
  }
}

function error(...data: any[]) {
  if (enable()) {
    console.error(data);
  }
}

function warn(...data: any[]) {
  if (enable()) {
    console.warn(data);
  }
}

function alert(...data: any[]) {
  if (enable()) {
    window.alert(data);
  }
}

export default {
  log,
  info,
  debug,
  error,
  warn,
  alert,
};
